import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePublishedInsightAccess } from "@/hooks/usePublishedInsightAccess";

// Phase 3 (F6): adviser "Insights" surface — the published-insight tier.
//
// Advisers are entitled to the `insight_published` surface, gated here by the F5 UX hook
// `usePublishedInsightAccess()` (true for staff OR a confirmed adviser). There is not yet a
// dedicated `published_insight` marketing table — today insights live as a staff-only blog
// tier — so rather than read a proprietary source, this surface shows an honest explainer
// until the published-insight feed exists. The real read wall is Phase 2 tier RLS regardless.

export default function AdviserInsights() {
  const { loading, canReadPublishedInsight } = usePublishedInsightAccess();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Insights</h2>
        <p className="text-muted-foreground">Published research insights for advisers.</p>
      </div>

      {!canReadPublishedInsight ? (
        <Card>
          <CardHeader>
            <CardTitle>No access to published insights</CardTitle>
            <CardDescription>
              This surface is available to advisers and CBAM team members. If you believe you
              should have access, please contact your CBAM relationship manager.
            </CardDescription>
          </CardHeader>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>Published insights are coming soon</CardTitle>
            <CardDescription>
              Your access to published research insights is set up. The insight feed will appear
              here as CBAM publishes adviser-facing research. In the meantime, see the Commentary
              and Portfolios tabs for our latest published views.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            No published insights have been released yet.
          </CardContent>
        </Card>
      )}
    </div>
  );
}
